module.exports = __webpack_public_path__ + "static/media/19068_1318012037100_2029381_n.a9091120.jpg";